module.exports = __webpack_public_path__ + "f7c8e044edbb965a45d8fe64c918cff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/Trash.svg
// module id = 1050
// module chunks = 0